(function () {
  var STORAGE_PREFIX = "baci-scroll-position:";
  var MAX_RESTORE_ATTEMPTS = 120;
  var RESTORE_RETRY_DELAY = 50;

  if (!window || !document) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var storage;
  try {
    storage = window.sessionStorage;
  } catch (error) {
    return;
  }

  if (!storage) return;

  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch (error) {
    // Some embedded browsers expose history but reject assignment.
  }

  var restoreTimer = null;
  var restoreTarget = null;
  var restoreAttempts = 0;

  function getStorageKey() {
    return STORAGE_PREFIX + window.location.pathname + window.location.search;
  }

  function getPageHeight() {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(
      body ? body.scrollHeight : 0,
      html ? html.scrollHeight : 0
    );
  }

  function sanitizePosition(position) {
    if (!position || typeof position !== "object") return null;

    var x = Number(position.x);
    var y = Number(position.y);

    if (!isFinite(x) || !isFinite(y)) return null;

    return {
      x: Math.max(0, Math.round(x)),
      y: Math.max(0, Math.round(y))
    };
  }

  function readPosition() {
    try {
      return sanitizePosition(JSON.parse(storage.getItem(getStorageKey())));
    } catch (error) {
      return null;
    }
  }

  function savePosition() {
    try {
      storage.setItem(
        getStorageKey(),
        JSON.stringify({
          x: window.pageXOffset || 0,
          y: window.pageYOffset || 0
        })
      );
    } catch (error) {
      // Storage can be full or blocked. Native scrolling remains unchanged.
    }
  }

  function scheduleRestoreAttempt() {
    restoreTimer = window.setTimeout(tryRestorePosition, RESTORE_RETRY_DELAY);
  }

  function tryRestorePosition() {
    if (!restoreTarget) return;

    var maxScrollableY = Math.max(0, getPageHeight() - window.innerHeight);
    var canReachSavedPosition = maxScrollableY >= restoreTarget.y;
    var outOfRetries = restoreAttempts >= MAX_RESTORE_ATTEMPTS;

    if (canReachSavedPosition || outOfRetries) {
      window.scrollTo(restoreTarget.x, restoreTarget.y);
      restoreTarget = null;
      restoreAttempts = 0;
      return;
    }

    restoreAttempts += 1;
    scheduleRestoreAttempt();
  }

  function restorePosition() {
    if (window.location.hash) return;

    var position = readPosition();
    if (!position) return;

    if (restoreTimer) {
      window.clearTimeout(restoreTimer);
    }

    restoreTarget = position;
    restoreAttempts = 0;
    tryRestorePosition();
  }

  function shouldSaveLinkClick(event) {
    var link = event.target && event.target.closest
      ? event.target.closest("a[href]")
      : null;

    if (!link) return false;

    var href = link.getAttribute("href");
    if (!href || href.charAt(0) === "#" || href.indexOf("javascript:") === 0) {
      return false;
    }

    return true;
  }

  window.addEventListener("pagehide", savePosition);
  window.addEventListener("beforeunload", savePosition);
  window.addEventListener("pageshow", restorePosition);
  window.addEventListener("load", restorePosition);

  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") {
      savePosition();
    }
  });

  document.addEventListener("click", function (event) {
    if (shouldSaveLinkClick(event)) {
      savePosition();
    }
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restorePosition);
  } else {
    restorePosition();
  }
})();
